export enum MastermindSectionEnum {
    active = "published",
    archived = "draft"
}